export default {
  methods: {
    getReqConfig(additionalHeaders) {
      let provider = this.$store.getters.getAuthProvider;
      var token = this.$store.getters.getToken;
      let tenantId = this.$store.getters.getTenantId;

      return this.$auth.getReqConfig(token, provider, tenantId, additionalHeaders);
    },
    defaultRedirect(nextUrl, query) {
      if (query === undefined) {
        query = {
        };
      }
      
      if (this.accountUser != null && this.accountUser.setup === false) {
        this.$store.dispatch("setPauseAuth", true);
        query = {
          uid: this.accountUser.userId
        }
        this.$router.push({ name: "Account Setup", query: query })
      }
      else if (this.accountUser != null && (!this.$store.getters.getTenantId || this.accountUser.multiTenant)) {
        this.$router.push({ name: "Choose Tenant", query: query })
      }
      else if (nextUrl) {
        this.$router.push(nextUrl);
      } else if (this.accountUser != null && this.accountUser.sponsor) {
        this.$router.push({ name: "Overview", query: query });
      } else if (this.accountUser != null && this.accountUser.admin) {
        this.$router.push({ name: "ProjectPages", query: query });
      } else if (this.accountUser != null && this.isSystemAdmin) {
        this.$router.push({ name: "Project List" });
      } else {
        this.$router.push({ name: "Settings", query: query });
      }
    }
  },
  computed: {
    accountUser() {
      return this.$store.getters.getUser;
    },
    isSystemAdmin() {
      let user = this.$store.getters.getUser;
      return user != null && user.systemAdmin;
    },
    context() {
      return this.$store.getters.getContext;
    }
  }
}